import React from 'react';
import { useDriverSchedule } from '../hooks/useDriverSchedule';
import { useUser } from '@store';
import { OneOffDaysManager } from '@components/OneOffDays';
import type { Businesshours_Insert_Input, Drivers } from '@gql/base-types';
import { getDriverTimezone } from '@utils/timezoneUtils';

interface DriverOneOffDaysProps {
  driver: Drivers;
  open: boolean;
  onClose: () => void;
}

const DriverOneOffDays: React.FC<DriverOneOffDaysProps> = ({ driver, open, onClose }) => {
  const user = useUser();
  const driverId = driver?.id?.toString();
  const timezone = getDriverTimezone(driver);
  const userName = user?.profile?.display_name || 'Unknown';

  const { driverSchedule, createDriverSchedule, deleteDriverSchedule, creating, deleting } =
    useDriverSchedule(driverId);

  // Wrapper function to adapt to GraphQL mutation signature
  const handleCreate = async (oneOffDays: Businesshours_Insert_Input[]) => {
    await createDriverSchedule({ variables: { driverSchedule: oneOffDays } });
  };

  if (!driverId) {
    return null;
  }

  return (
    <OneOffDaysManager
      config={{
        entityType: 'driver',
        entityId: driverId,
        entityName: 'Driver',
        timezone: timezone,
        labels: {
          title: 'Manage Driver One-Off Days',
          addButtonText: 'ADD A NEW ENTRY',
          unavailableLabel: 'Unavailable',
          partialAvailabilityLabel: 'Available From',
          noEntriesText: 'No one-off days scheduled',
        },
      }}
      oneOffDays={driverSchedule}
      onCreate={handleCreate}
      onDelete={deleteDriverSchedule}
      loading={creating || deleting}
      userName={userName}
      open={open}
      onClose={onClose}
    />
  );
};

export default DriverOneOffDays;
